<img class="app-bg-image" [src]="commonService.resource.image.help_us_bg" alt="">
<div class="home-bg app-container">
    <div class="content-container menu-bg">
        <div class="row m-0">
            <div class="col-md-2 p-0"></div>
            <div class="col-sm-12 col-md-4 p-0">
                <div class="">
                    <div class="app-heading d-block" [innerHTML]="('helpUs.title' | translate)">
                    </div>
                    <div class="app-content-body">
                        <span>{{'helpUs.content' | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 p-0">
                <div class="mt-5 main-content">
                    <div class="form-floating">
                        <input type="email" class="form-control" [ngClass]="{'invalid': isInvalid == 'email'}" placeholder="Email" [(ngModel)]="email">
                        <label>{{ 'helpUs.email' | translate }}</label>
                    </div>
                    <div class="form-floating">
                        <input type="number" class="form-control" [ngClass]="{'invalid': isInvalid == 'age'}" id="floatingInput" placeholder="Age" [(ngModel)]="age">
                        <label for="floatingInput">{{ 'helpUs.age' | translate }}</label>
                    </div>
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInput" placeholder="Gender" [(ngModel)]="gender">
                        <label for="floatingInput">{{ 'helpUs.gender' | translate }}</label>
                    </div>
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInput" placeholder="Sexuality" [(ngModel)]="sexuality">
                        <label for="floatingInput">{{ 'helpUs.sexuality' | translate }}</label>
                    </div>
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInput" placeholder="City" [(ngModel)]="city">
                        <label for="floatingInput">{{ 'helpUs.city' | translate }}</label>
                    </div>
                </div>
                <div class="row mt-4 main-content mobile-hide">
                    <div class="col-7 p-0">
                        <button mat-button class="primary-button w-100" (click)="saveChanges()">
                            {{ 'helpUs.save' | translate}}
                        </button>
                    </div>
                    <div class="col-5">
                        <button mat-button class="secondary-button w-100 h-100" (click)="navToHome()">
                            {{  'helpUs.skip' | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-12 mobile-hide p-0"></div>
        </div>
    </div>
</div>
<div class="home-bg h-100 mobile-show">
    <div class="row m-0 p-4">
        <div class="col-7 p-0">
            <button mat-button class="primary-button w-100" (click)="saveChanges()">
                {{ 'helpUs.save' | translate}}
            </button>
        </div>
        <div class="col-5">
            <button mat-button class="secondary-button w-100 h-100" (click)="navToHome()">
                {{  'helpUs.skip' | translate}}
            </button>
        </div>
    </div>
</div>